import type { GetMonthShortLabelParams } from '../types';

const MONTH_SHORT_LABELS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
] as const;

const getMonthShortLabel = ({ monthIndex }: GetMonthShortLabelParams): string =>
    MONTH_SHORT_LABELS[monthIndex];

export default getMonthShortLabel;
